import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import ServiceHero from '../components/services/ServiceHero';
import ServiceCategories from '../components/services/ServiceCategories';
import ServiceTestimonials from '../components/services/ServiceTestimonials';
import ServiceCTA from '../components/services/ServiceCTA';

const Services = () => {
  return (
    <div id="services">
      <Navbar />
      <ServiceHero />
      <ServiceCategories />
      <ServiceTestimonials />
      <ServiceCTA />
      <Footer />
    </div>
  );
};

export default Services;
